import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import classNames from "classnames";
import FAIcon from "../../UI/FAIcon/FAIcon";
import FormQuestionDomainService from "../../../Domain/FormQuestion/FormQuestion.service";
const sortQuestionsByFieldLabel = (a, b) => {
    const labelA = a.fieldLabel.toLowerCase();
    const labelB = b.fieldLabel.toLowerCase();
    if (labelA < labelB) {
        return -1;
    }
    if (labelA > labelB) {
        return 1;
    }
    return 0;
};
const DropdownSection = ({ section, onSelection, }) => {
    if (section.fields.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx("h6", { className: "dropdown-header", children: section.name }), section.fields.map((formQuestion) => (_jsx("li", { children: _jsx("button", { className: "dropdown-item", onClick: () => onSelection(formQuestion), children: formQuestion.fieldLabel }) }, formQuestion.id)))] }));
};
const FormQuestionDropdown = ({ formQuestions, onSelection, }) => {
    // This is a hacky way to sort the form questions into sections. This should be improved
    // by adding a section field to the form question model.
    const formSections = useMemo(() => {
        const biographicalInformationFieldsSection = {
            name: "Biographical Information",
            fields: formQuestions.filter((fq) => [
                FormQuestionDomainService.highSchool.id,
                FormQuestionDomainService.gender.id,
                FormQuestionDomainService.race.id,
                FormQuestionDomainService.ethnicity.id,
                FormQuestionDomainService.birthdate.id,
            ].includes(fq.id)),
        };
        const contactInformationFieldsSection = {
            name: "Contact Information",
            fields: formQuestions.filter((fq) => [
                FormQuestionDomainService.firstName.id,
                FormQuestionDomainService.middleName.id,
                FormQuestionDomainService.lastName.id,
                FormQuestionDomainService.emailAddress.id,
                FormQuestionDomainService.address.id,
                FormQuestionDomainService.phoneNumber.id,
            ].includes(fq.id)),
        };
        const freeTextFieldsSection = {
            name: "Free Text",
            fields: formQuestions.filter((fq) => [
                FormQuestionDomainService.shortAnswer.id,
                FormQuestionDomainService.paragraph.id,
            ].includes(fq.id)),
        };
        const academicInterestFieldsSection = {
            name: "Academic Interest",
            fields: formQuestions.filter((fq) => [
                FormQuestionDomainService.intendedStartTerm.id,
                FormQuestionDomainService.programInterest.id,
                FormQuestionDomainService.departmentInterest.id,
            ].includes(fq.id)),
        };
        const otherFields = {
            name: "Others",
            fields: formQuestions.filter((fq) => ![
                ...biographicalInformationFieldsSection.fields,
                ...contactInformationFieldsSection.fields,
                ...freeTextFieldsSection.fields,
                ...academicInterestFieldsSection.fields,
            ].includes(fq)),
        };
        return [
            biographicalInformationFieldsSection,
            contactInformationFieldsSection,
            academicInterestFieldsSection,
            freeTextFieldsSection,
            otherFields,
        ];
    }, [formQuestions]);
    formSections.forEach((section) => {
        section.fields.sort(sortQuestionsByFieldLabel);
    });
    return (_jsxs("div", { className: "dropdown w-100 mt-2", children: [_jsxs("button", { className: "btn btn-outline-primary", type: "button", id: "dropdownMenuButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", children: [_jsx(FAIcon, { icon: "plus-circle", addMarginRight: true }), "Add Question"] }), _jsx("ul", { className: classNames("dropdown-menu", "overflow-auto", "custom-scrollbar"), style: { maxHeight: "220px" }, "aria-labelledby": "dropdownMenuButton", children: formSections.map((section, index) => (_jsx(DropdownSection, { section: section, onSelection: onSelection }, index))) })] }));
};
export default FormQuestionDropdown;
